import { IUserCognitoInfoModel } from '@features/auth-amplify/models';

/**
 * Cognito attributes sometimes arrive as real booleans or string booleans (e.g., email_verified can be true or 'true').
 * This helper normalizes those cases into a strict boolean. It is intentionally conservative:
 *  - Accepts boolean true
 *  - Accepts string 'true' (case-insensitive)
 *  - Everything else is treated as false
 */
export const parseBooleanAttribute = (value: unknown): boolean => {
  if (value === true) return true;
  if (typeof value === 'string') return value.toLowerCase() === 'true';
  return false;
};

export const mapCognitoAttributes = (cognitoAttributes): IUserCognitoInfoModel => ({
  id: cognitoAttributes.sub,
  email: cognitoAttributes.email,
  // email_verified may be a boolean or a string depending on the source; normalize it
  isEmailVerified: parseBooleanAttribute(cognitoAttributes.email_verified),
});
